var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourtHouse = function SvgCourtHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.27 21.64H.21v-3.91h37.05v3.91h.01Zm-36.06-1h35.05v-1.91H1.21v1.91Zm36.27 13.03H0v1h37.48v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.93 18.73H8.71v-.5a10.12 10.12 0 0 1 20.22 0v.5Zm-19.21-1h18.2a9.12 9.12 0 0 0-18.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 3.5h-1v5.11h1V3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.31 6.7h-3.99V3h3.99v3.7Zm-2.99-1h1.99V4h-1.99v1.7ZM5.48 21.14h-1v13.04h1V21.14Zm-2.8 0h-1v13.04h1V21.14Zm5.6 0h-1v13.04h1V21.14Zm2.8 0h-1v13.04h1V21.14Zm12.46 13.03h-1v-6.93h-7.43v6.93h-1v-7.93h9.43v7.93Zm4.1-13.03h-1v13.04h1V21.14Zm2.8 0h-1v13.04h1V21.14Zm2.8 0h-1v13.04h1V21.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.24 21.14h-1v13.04h1V21.14Zm2.8 0h-1v13.04h1V21.14Zm-16.72 5.6h-1v7.44h1v-7.44Z"
  }))));
};
export default SvgCourtHouse;